<template>
  <html>
    <head> </head>
    <body>
      <div class="container-fluid">
        <div class="row fixheader header-banner">
          <!--img
            id="header-s"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-s.png"
          /-->
          <div class="text-center">
            <h1>ลงทะเบียน</h1>
          </div>
        </div>
        <div class="row">
          <div id="lh-form" style="padding-left: 0px">
            <form method="post" @submit="register">
              <div class="form-group">
                <label for="title" class="text-form">คำนำหน้า *</label>
                <select
                  type="text"
                  class="form-control"
                  id="title"
                  placeholder="คำนำหน้า"
                  v-model="regForm.title"
                >
                  <option v-for="item in title" :key="item.key" :value="item.key">
                    {{ item.value }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="firstname" class="text-form">ชื่อ (ภาษาไทย) *</label>
                <input
                  type="text"
                  class="form-control"
                  id="firstname"
                  placeholder=""
                  required
                  v-model="regForm.firstname"
                />
              </div>
              <div class="form-group">
                <label for="lastname" class="text-form">นามสกุล (ภาษาไทย) *</label>
                <input
                  type="text"
                  class="form-control"
                  id="lastname"
                  placeholder=""
                  requried
                  v-model="regForm.lastname"
                />
              </div>

              <div class="form-group">
                <label for="idcard" class="text-form">บัตรประชาชน( 13 หลัก ) *</label>
                <input
                  type="text"
                  class="form-control"
                  id="idcard"
                  placeholder=""
                  requried
                  v-model="regForm.id_number_loyalty"
                  @input="isNumberValid('id', $event)"
                  maxlength="13"
                  minlength="13"
                />
                <div class="error" v-if="!isValid">กรุณากรอกเฉพาะตัวเลข</div>
              </div>

              <!--div class="form-group">
                <label for="genders" class="text-form">เพศ *</label>
                <select
                  type="text"
                  class="form-control"
                  id="genders"
                  placeholder="เลือกเพศสภาพ"
                  v-model="regForm.genders"
                >
                  <option v-for="item in genders" :key="item.key" :value="item.key">
                    {{ item.value }}
                  </option>
                </select>
              </div-->
              <div class="form-group">
                <label for="email" class="text-form">อีเมล *</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  placeholder="youremail@email.com"
                  required
                  v-model="regForm.email"
                />
              </div>
              <div class="form-group">
                <label for="phone" class="text-form">เบอร์โทรศัพท์มือถือ *</label>
                <input
                  type="text"
                  class="form-control"
                  id="phone"
                  placeholder=""
                  v-model="regForm.phone"
                  maxlength="10"
                  minlength="10"
                  @input="isNumberValid('phone', $event)"
                />
                <div class="error" v-if="!isValidPhone">กรุณากรอกเฉพาะตัวเลข</div>
              </div>
              <div class="form-group">
                <label for="birthdate" class="text-form">วันเกิด (ค.ศ.) *</label>
                <date-dropdown
                  min="1900"
                  max="2021"
                  v-model="birthdate"
                  class="fixdd"
                  months-names="มกราคม,กุมภาพนธ์,มีนาคม,เมษายน,พฤษภาคม,มิถุนายน,กรกฎาคม,สิงหาคม,กันยายน,ตุลาคม,พฤศจิกายน,ธันวาคม"
                  style="width: 100%; border: 0"
                  valueType="format"
                ></date-dropdown>
              </div>

              <div class="form-group">
                <label for="projects" class="text-form">โครงการ *</label>
                <select
                  type="text"
                  class="form-control"
                  id="projects"
                  placeholder="โครงการ"
                  v-model="regForm.project_ticket"
                >
                  <option
                    v-for="item in projectsList"
                    :key="item.key"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="house_number_ticket" class="text-form">บ้านเลขที่ *</label>
                <input
                  type="text"
                  class="form-control"
                  id="house_number_ticket"
                  placeholder=""
                  requried
                  v-model="regForm.house_number_ticket"
                />
              </div>
              <div class="form-group">
                <label for="number_of_residents" class="text-form"
                  >จำนวนผู้อยู่อาศัย *</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="number_of_residents"
                  placeholder=""
                  requried
                  v-model="regForm.number_of_residents"
                />
              </div>

              <div class="form-group">
                <label for="n5__" class="text-form"
                  >จำนวนผู้อยู่อาศัยที่มีอายุต่ำกว่า 5 ปี *</label
                >
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  id="n5__"
                  placeholder=""
                  requried
                  v-model="regForm.n5__"
                />
              </div>

              <div class="form-group">
                <label for="n60___" class="text-form"
                  >จำนวนผู้อยู่อาศัยที่มีอายุมากกว่า 60 ปี *</label
                >
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  id="n60___"
                  placeholder=""
                  requried
                  v-model="regForm.n60___"
                />
              </div>

              <div class="form-group">
                <label for="live_status_contact" class="text-form">สถานะลูกบ้าน *</label>
                <select
                  type="text"
                  class="form-control"
                  id="live_status_contact"
                  placeholder="โครงการ"
                  v-model="regForm.live_status_contact"
                >
                  <option
                    v-for="item in resident_status"
                    :key="item.key"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </div>


              <!--div class="form-group">
                <label for="activities" class="text-form">กิจกรรมที่สนใจ</label>
              </div>
              <div
                class="form-check form-check-inline"
                v-for="item in activitiesList"
                :key="item.key"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="item.value"
                  :value="item.value"
                  v-model="interestedActivities"
                />
                <label class="form-check-label" :for="item.value">{{ item.text }}</label>
              </div>
              <div class="form-group">
                <label for="other_interest" class="text-form">ความสนใจอื่น ๆ</label>
                <textarea
                  class="form-control"
                  id="other_interest"
                  placeholder=""
                  requried
                  v-model="regForm.other_interest"
                ></textarea>
              </div-->
              <!--div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
                  <label class="form-check-label" for="inlineCheckbox2">2</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox3" value="option3" disabled>
                  <label class="form-check-label" for="inlineCheckbox3">3 (disabled)</label>
                </div-->

              <button
                type="submit"
                class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
                v-if="registered === false"
                :disabled="checkRequired"
              >

                บันทึก
              </button>
            </form>
          </div>
        </div>
      </div>
    </body>
  </html>
</template>
<script>
//import VCalendar from "v-calendar";
//import DatePicker from "vue2-datepicker";
import axios from "axios";
//import "vue2-datepicker/index.css";
import DateDropdown from "vue-date-dropdown";
//import SelectBirthdate from "./Birthdate";
//import DropdownDatepicker from "vue-dropdown-datepicker";

export default {
  name: "",
  components: {
    //"v-calendar": VCalendar,
    //"date-picker": DatePicker,
    "date-dropdown": DateDropdown,
  },
  watch: {
    interestedActivities: {
      handler(val) {
        console.log(val);
      },
    },
  },
  data() {
    return {
      success: false,
      // hubspot
      projects: "",
      project_ticket: "",
      hubspot_url: "https://api.hubapi.com",
      projectsList: [],
      activitiesList: [],
      interestedActivities: [],
      isValid: true,
      isValidPhone: true,
      regex: /[0-9]/,
      number_of_residents: "",
      id_number_loyalty: "",
      house_number_ticket: "",
      registered: false,
      resident_status:[],
      n60___: "",
      n5__: "",
      regForm: {
        line_id: localStorage.getItem("line_id"),
        line_img: localStorage.getItem("line_img"),
        email: localStorage.getItem("line_email"), // || this.$state.state.lineInfo.email,
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
        custName: "Areeya",
        firstname: "", //localStorage.getItem("line_name"),
        lastname: "",
        phone: "",
        birthdate: "",
        title: "",
        project_ticket: "",
        interestedActivities: "",
        id_number_loyalty: "",
        number_of_residents: "",
        house_number_ticket: "",
        other_interest: "",
        live_status_contact:"",
        n5__:"",
        n60___:"",


        // localStorage.setItem("line_id", profile.userId);
        //       //localStorage.setItem("line_email", profile.email);
        //       localStorage.setItem("line_name", profile.displayName);
        //       localStorage.setItem("line_img", profile.pictureUrl);
      },

      birthdate: "",
      genders: [
        { key: "M", value: "ชาย" },
        { key: "F", value: "หญิง" },
        { key: "N", value: "ไม่ระบุ" },
      ],
      title: [
        { key: "นาย/Mr.", value: "นาย" },
        { key: "นาง/Mrs.", value: "นาง" },
        { key: "นางสาว/Ms.", value: "นางสาว" },
      ],
    };
  },
  computed: {
    // phone() {
    //   return this.$store.state.info.phone;
    // },
    checkRequired() {
      let required = [
        "title",
        "firstname",
        "lastname",
        "idcard",
        "project_ticket",
        "house_number_ticket",
        "number_of_residents",
        "live_status_contact",
        "n5__",
        "n60___"

      ];
      for (const [key, value] of Object.entries(this.regForm)) {

        if (required.includes(key) === true) {
          if (value == "" && typeof this.regForm[key] !== "object") {
            return true;
          }
        }
      }

      return false;
    },
  },

  mounted() {
    //console.log("mounted reg2");
    //alert(JSON.stringify(this.$route.query));
    //alert(JSON.stringify(this.$route.query.apiKey));
    //console.log(process.env.VUE_APP_LOYALTY_API_URI);

    // get hubspot property value
    // ticket_project

    this.initial();
    //this.regForm.n5__ = 0;
    //this.regForm.n60___ = 0;

    if (this.$store.state.lineInfo._id !== undefined) {
      this.regForm.phone = this.$store.state.lineInfo.phone;
      this.regForm.birthdate = this.$store.state.lineInfo.birthdate;
      this.regForm.firstname = this.$store.state.lineInfo.firstname;
      this.regForm.lastname = this.$store.state.lineInfo.lastname;
      this.regForm.title = "นาย/Mr.";
    }
    //alert(JSON.stringify(this.$store.state.lineInfo))
  },
  methods: {
    isNumberValid: function (type, inputNumber) {
      console.log(inputNumber);
      if (inputNumber.data !== null) {
        if (type == "id") {
          this.isValid = this.regex.test(inputNumber.data);
        } else {
          this.isValidPhone = this.regex.test(inputNumber.data);
        }
      }
    },
    async initial() {

      //live_status_contact
      await axios
        .get(
          "/crm/v3/properties/contacts/live_status_contact?archived=false",
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Credentials": true,
              "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
              "authorization": "Bearer pat-na1-ce464e54-97ed-4e17-9fa5-b6dd5d624404",
              withCredentials: true,
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.options.length > 0) {
            this.resident_status = response.data.options.map((item) => {
              return { text: item.label, value: item.value };
            });
          }
        });



      //try{
      //let object = "tickets";
      //let property = "project_ticket";
      //axios.defaults.baseURL = "/hubspot";
      await axios
        .get(
          "/crm/v3/properties/tickets/project_ticket?archived=false",
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Credentials": true,
              "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
              "authorization": "Bearer pat-na1-ce464e54-97ed-4e17-9fa5-b6dd5d624404",
              withCredentials: true,
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.options.length > 0) {
            this.projectsList = response.data.options.map((item) => {
              return { text: item.label, value: item.value };
            });
          }
        }); //+localStorage.getItem("apiKey"));
      //console.log(this.projectsList);
      /*
      await axios
        .get(
          "/crm/v3/properties/contacts/interest_activities?archived=false&hapikey=87d75c3a-0996-4c2f-a3c1-e5c972cf6f2f",
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Credentials": true,
              "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
              withCredentials: true,
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.options.length > 0) {
            this.activitiesList = response.data.options.map((item) => {
              return { text: item.label, value: item.value };
            });
          }
        }); //+localStorage.getItem("apiKey"));
      //console.log(this.activitiesList);
      //}catch(err){
      //  console.log(err);
      //}

      /* axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      var config = {
        method: 'get',
        url: '/hubspot/properties/tickets/project_ticket?archived=false&hapikey=87d75c3a-0996-4c2f-a3c1-e5c972cf6f2f',
        headers: {'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',"Access-Control-Allow-Credentials": "true" }
      };

      axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });
      */
    },

    validate() {},
    async register(e) {
      e.preventDefault();
      //console.log(this.regForm);
      let birthdate = this.birthdate.split(".");
      this.regForm.birthdate = birthdate[2] + "-" + birthdate[1] + "-" + birthdate[0];
      //this.regForm.birthdate = birthdate[0];
      if (this.regForm.title == "นาย/Mr.") {
        this.regForm.genders = "M";
      } else {
        this.regForm.genders = "F";
      }
      this.regForm.interestedActivities = this.interestedActivities.toString();
      this.registered = true;

      /***** if validate ******/
      await this.$store.dispatch("addMember", this.regForm);
      //let isSuccess = this.$store.getters.isSuccess;
      //alert(this.$store.getters.isSuccess);
      if (this.$store.state.isSuccess) {
        this.$toast.success("บันทึกข้อมูลสำเร็จ", {
          timeout: 2000,
        });
        //window.location.href = "https://line.me/R/ti/p/@611wlcwi"
        this.$router.push({
          name: "Profile",
        });
      } else {
        this.$toast.error("บันทึกข้อมูลไม่สำเร็จ", {
          timeout: 2000,
        });
      }
    },
  },
};
</script>
<style scoped>
@import "./Css/style.css";
.fixheader {
  top: 0 !important;
  margin-top: 0;
  min-height: 80px !important;
  border-radius: 0 0 30px 30px;
  padding-top: 15px;
}
h1 {
  clear: both;
  font-size: 20px;
  color: #ffffff;
  padding-left: 0px;
}
.btn-block {
  display: block;
  width: 100%;
  margin-top: 51px;
}
.text-center {
  text-align: left !important;
  margin-left: 0px;
}
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  margin-right: 2px;
  margin-left: 0px;
  margin-top: 85px;
}
.mx-datepicker-main.mx-datepicker-popup {
  position: absolute;
  top: 490px;
  left: 21px;
}
.select#month {
  width: 54%;
}
.fixdd select#month {
  color: gray !important;
  border-color: #ced4da !important;
}
</style>
